import { ActionCreators } from "redux-undo";
import { importStateAsync, selectNavItem } from "./actions.es6";
import { getEditorPlayhead } from "./playhead_tracker.es6";
import { getBaseUpdatedAt, setBaseUpdatedAt } from "./saveConflict.es6";
import { FPS } from "./sceneTimeline.es6";

export function getContext(store) {
  const state = store.getState();
  const present = state.undoGroup.present;
  const navId = state.navItemSelected;
  const playhead = getEditorPlayhead();
  const all = state.boxSelectedAll;
  const one = typeof state.boxSelected === "string" ? [state.boxSelected] : [];
  const selectedBoxIds = Array.isArray(all) && all.length ? all : one;
  return {
    trainingId: window.idealStudioTrainingId,
    navId,
    sceneTitle: present.navItemsById?.[navId]?.name,
    playheadSec: playhead ? playhead.frame / FPS : 0,
    selectedBoxIds,
  };
}

// Re-fetch the training (like EditorApp._reloadServerCopy), keep the open scene.
function reload(store) {
  const prevNav = store.getState().navItemSelected;
  return store
    .dispatch(
      importStateAsync(window.idealStudioTrainingId, window.tenantId, (r) =>
        setBaseUpdatedAt(r.updatedAt)
      )
    )
    .then(() => {
      if (store.getState().undoGroup.present.navItemsById?.[prevNav]) {
        store.dispatch(selectNavItem(prevNav));
      }
    });
}

function save(store) {
  return new Promise((resolve, reject) => {
    window.ideaEnvSaveState(
      store.getState(),
      false,
      () => resolve({ ok: true }),
      (err) => (err && err.isSaveConflict ? resolve({ conflict: true }) : reject(err))
    );
  });
}

export function installAideaBridge(store) {
  window.aideaBridge = {
    reload: () => reload(store),
    save: () => save(store),
    getContext: () => getContext(store),
    getBaseUpdatedAt: () => getBaseUpdatedAt(),
    isDirty: () => !!window.aideaDirty,
  };
  const emit = () =>
    window.dispatchEvent(new CustomEvent("aidea:context", { detail: getContext(store) }));
  let last = "";
  store.subscribe(() => {
    const s = store.getState();
    const key = `${s.navItemSelected}|${JSON.stringify(s.boxSelectedAll)}|${s.boxSelected}`;
    if (key !== last) {
      last = key;
      emit();
    }
  });
  // Playhead lives outside redux: seek/play events from the timeline, throttled.
  let timer = null;
  const throttled = () => {
    if (timer) return;
    timer = setTimeout(() => {
      timer = null;
      emit();
    }, 500);
  };
  document.addEventListener("aidea-timeline-seek", throttled);
  document.addEventListener("aidea-timeline-status", throttled);
}
